export default __webpack_public_path__ + "static/media/lacoste.c5287866.svg";